import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  initializeMetaPixel,
  trackMetaPixelPageView,
} from "../../utils/metaPixel";

const MetaPixelTracker: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    initializeMetaPixel();
  }, []);

  useEffect(() => {
    trackMetaPixelPageView();
  }, [location.hash, location.pathname, location.search]);

  return null;
};

export default MetaPixelTracker;

